<template>
  <div class="dealership-address" :class="brand.name">
    <div v-if="brand.name === 'bmw' || brand.name === 'mazda' || brand.name === 'lexus' || brand.name === 'subaru' || brand.name === 'ford'" class="top-banner" :class="brand.name">
      <div class="address-row-container" :class="brand.name">
        <div>{{ dealer.name }}</div>
        <a class="dealership-url" v-bind:href="$store.getters.googleMapLink" rel="noopener" target="_blank" aria-label="link to dealership">
          <div class="dealer-address-collapse" id="dealer-address-collapse" :class="brand.name" v-on:click="trackClickOnLocation">
            <div class="seperator">&#124;</div>
            <div id="dealer-streetaddress">{{ dealer.address.street }}&#44;</div>
            <div id="dealer-city">{{ dealer.address.city }} {{ dealer.address.state }} {{ dealer.address.zip }}</div>
            <div class="seperator">&#124;</div>
          </div>
        </a>
        <div id="phone-container" class="phone-container-row" :class="brand.name">
          <DealerPhone :brand="brand" :dealer="dealer" id="dealership-phone" class="dealership-phone" v-show="showPhoneDetails"></DealerPhone>
        </div>
      </div>
    </div>
    <div v-if="brand.name !== 'bmw' && brand.name !== 'mazda' && brand.name !== 'lexus' && brand.name !== 'subaru' && brand.name !== 'ford'" :class="brand.name">
      <div class="dealership-name">
          <a class="dealership-url" :class="brand.name" :href="dealer.url.home" rel="noopener" target="_blank" aria-label="link to dealership">{{ dealer.name }}</a>
      </div>
      <div id="dealership-streetaddress" class="dealership-streetaddress" v-on:click="trackClickOnLocation">
         <a class="dealership-url" v-bind:href="$store.getters.googleMapLink" rel="noopener" target="_blank" aria-label="link to dealership">{{ dealer.address.street | addressFormatter(dealer.address.city, dealer.address.state, dealer.address.zip) }}</a>
      </div>
      <div class="phone-container">
        <DealerPhone :brand="brand" :dealer="dealer" class="dealership-phone"></DealerPhone>
      </div>
    </div>
  </div>
</template>

<script>
import DealerPhone from '@/components/DealerPhone'
export default {
  name: 'DealerInfo',
  props: {
    brand: Object,
    dealer: Object,
    showPhoneDetails: Boolean
  },
  components: {
    DealerPhone
  },
  methods: {
    trackClickOnLocation () {
      this.$store.dispatch('track/gaEvent', { vm: this, category: 'location', action: 'click', label: 'address' })
      this.$store.dispatch('track/facebookEvent', { event: 'Loc-Click-Address' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top-banner {
  border: 1px solid var(--top-Banner-background-color);
  background-color: var(--top-Banner-background-color);
  position: relative;
  height: 56px;
  padding-right: 1rem;
  font-size: 12px;
}
.address-row-container{
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  height: 100%;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  z-index: 1;
  position: relative;
}
.seperator {
  padding-left: 2px;
  padding-right: 2px;
}
.dealer-address-collapse {
  display: none;
  line-height: 1.2em;
  color: var(--banner-text-color);
}
.dealership-address{
  display: flex;
  justify-content: flex-end;
}
.dealership-address.bmw,
.dealership-address.lexus,
.dealership-address.subaru,
.dealership-address.ford  {
  background-color: var(--url-text-color);
}
.dealership-name {
  font-size: 16px;
  line-height: 1.5em;
  font-weight: bold;
}
.dealership-url {
  color: var(--url-text-color);
  text-decoration: none;
}
.dealership-url.bmw,
.dealership-phone.bmw,
.dealership-url.mazda,
.dealership-phone.mazda,
.dealership-url.lexus,
.dealership-phone.lexus,
.dealership-url.subaru,
.dealership-phone.subaru,
.dealership-url.ford,
.dealership-phone.ford  {
  color: var(--banner-text-color);
}
.phone-container {
  display: inline-block;
  flex-direction: row;
  font-size: 12px;
}
.dealership-phone,
.dealership-streetaddress {
  font-size: 14px;
  color: var(--url-text-color);
}
.dealership-phone.jaguar,
.dealership-streetaddress.jaguar,
.dealership-phone.land-rover,
.dealership-streetaddress.land-rover {
  font-size: 11px;
}
.dealership-name a.jaguar,
.dealership-name a.land-rover {
  font-size: 13px;
}
.phone-container-row {
    flex-basis: 100%;
    text-align: right;
}
.dealership-phone,
.dealership-font-size {
  font-size: 12px;
}
.dealership-address.lexus,
.dealership-address.subaru {
  font-weight: bold;
  letter-spacing: 1.2px;
}
.dealership-address.ford {
  letter-spacing: 1.2px;
}
.top-banner.ford {
  width: 100%
}
/*small device responsive style*/
@media only screen and (min-width: 576px) {
}
/*medium device responsive style*/
@media only screen and (min-width: 768px) {
  .dealer-address-collapse {
    display: flex;
    flex-direction: row;
  }
  .phone-container-row,
  .dealership-phone{
    flex-basis: auto;
    display: inline-block !important;
  }
}
/*large device responsive style*/
@media only screen and (min-width: 992px) {
  .top-banner,
  .phone-container-row,
  .dealership-phone {
    font-size: 14px;
  }
}
/*extra large device responsive style*/
@media only screen and (min-width: 1200px) {
  .dealership-font-size {
    font-size: 14px;
  }
}
</style>
